import { render, staticRenderFns } from "./BudgetAmountFields.vue?vue&type=template&id=181a2c1d&scoped=true&"
import script from "./BudgetAmountFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./BudgetAmountFields.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./BudgetAmountFields.vue?vue&type=style&index=0&id=181a2c1d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181a2c1d",
  null
  
)

export default component.exports